import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { DialogWithOptions } from '../common/DialogWithOptions';
import { DimensionTabLayout } from '../Layout';
function DimensionsTab(props) {
    var accessToken = props.oidc.user.access_token;
        const formRefs = useRef({});
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var currentUser = props.oidc.user;
    const priorityEntities = [
        { id: 1, text: "Modify Both Area and Volume Capacities" },
        { id: 2, text: "Modify Area Only Capacity" },
        { id: 3, text: "Modify Volume Only Capacity" },
        { id: 4, text: "Modify Neither" },
    ];
    const handleFieldChangeDimensions = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e, formRefs);
    }, []);
    const loadLookupClient = (name, data) => {
        try {
            const newOptions = data.map(item => ({
                id: item.Rowid,
                name: item.Code
            }));
            if (props.formRefs.current[name]) {

                props.formRefs.current[name].instance().option('dataSource', newOptions);
                props.formRefs.current[name].instance().option('valueExpr', 'id');
                props.formRefs.current[name].instance().option('displayExpr', 'name');
            }
        } catch (error) {
            console.error('Error fetching item detail:', error);
        } finally {
        }
    };
    const handleDimensionFormLoad = useCallback(() => {
        props.handleDimensionFormLoadCodes(formRefs);
    }, []);
    return (
        <>
            <div>
                <FormField
                    currrentUser={currentUser}
                    layoutId='A8F9F457-84C0-4B58-9265-3B58D4B46BC1'
                    layoutName='DimensionsForm'
                    defaultFormSchema={DimensionTabLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    handleFieldValueChange={handleFieldChangeDimensions}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    onFormLoad={handleDimensionFormLoad}
                    handleSelectedItemChange={handleFieldChangeDimensions}
                />
                {props.dialogVisible && (
                    <DialogWithOptions
                        closeDialog={props.closeDialog}
                        priorityEntities={priorityEntities}   
                        handleChangeDimensionButtonClick={props.handleChangeDimensionButtonClick}
                        selectionPriority={props.selectionPriority}
                        setSelectionPriority={props.setSelectionPriority}
                        formFields={props.formFields}
                        setformFields={props.setformFields}  
                    />
                )}
            </div>
        </>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(DimensionsTab);